import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ProfileApi, type ProfilePatch } from '../api/profile.api';
import { toAuthUser } from '../mappers/auth.mapper';
import type { AuthUser } from '../models/auth/user.model';
import type { ApiEnvelope } from './api-envelope';
import { apiPath, mapApiError, unwrapEnvelope } from './api-envelope';

@Injectable()
export class ProfileHttpApi extends ProfileApi {
  private readonly http = inject(HttpClient);

  override me(): Observable<AuthUser> {
    return this.http
      .get<ApiEnvelope<unknown> | null>(apiPath('/api/users/client/me'))
      .pipe(unwrapEnvelope<unknown>(), map(toAuthUser), mapApiError());
  }

  override updateProfile(patch: ProfilePatch): Observable<void> {
    const form = new FormData();
    // Пустая строка в photoUrl — команда удалить фото; отсутствие поля оставляет всё как есть.
    const client: Record<string, string | boolean> = {};
    if (patch.name !== undefined) {
      client['fullName'] = patch.name;
    }
    if (patch.photo === null) {
      client['photoUrl'] = '';
    }
    if (patch.language !== undefined) {
      // Enum бэкенда в верхнем регистре, как у /auth/code: любое другое значение — 400.
      client['language'] = patch.language.toUpperCase();
    }
    if (patch.updateFromTg !== undefined) {
      client['updateFromTg'] = patch.updateFromTg;
    }
    // JSON-часть обязана быть Blob с типом application/json, иначе бэкенд её не разберёт.
    form.append('client', new Blob([JSON.stringify(client)], { type: 'application/json' }));
    if (patch.photo instanceof File) {
      form.append('file', patch.photo);
    }
    // Content-Type не ставим: его вместе с boundary проставляет браузер.
    return this.http
      .put<ApiEnvelope<void> | null>(apiPath('/api/users/client/me'), form)
      .pipe(unwrapEnvelope<void>(), mapApiError());
  }
}
